import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetInstallationsCountByBranchResData } from "./GetInstallationsCountByBranchResData";

const ENDPOINT = "/branch/installationsCountByBranch";

export class GetInstallationsCountByBranchCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetInstallationsCountByBranchResData> {
        var res = await this.executeCommand();
        return new GetInstallationsCountByBranchResData(res);
    }
}
